import { render } from "./GameOver.vue?vue&type=template&id=315a9436&scoped=true"
import script from "./GameOver.vue?vue&type=script&lang=js"
export * from "./GameOver.vue?vue&type=script&lang=js"

import "./GameOver.vue?vue&type=style&index=0&id=315a9436&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315a9436"]])

export default __exports__